<template>
  <div class="info-see">
    <wh-breadcumb :list="breadcrumbList" />
    <wh-list
      ref="myList"
      class="level-list"
      :data-src="dataSrc"
      :extra-params="parameter"
      :get-list-data="getListData"
      :get-total-page-from-response="getTotal"
    >
      <template v-slot:listScope="{ listData }">
        <el-table
          :data="listData"
          border
          class="see-table"
          style="width: 100%;"
          :header-cell-style="tableHeaderCellStyle"
          :cell-style="tableCellStyle"
        >
          <el-table-column prop="index" label="序号" width="80">
            <template slot-scope="scope">
              <div class="wh-flex-center">
                {{ scope.row.index }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="standard_number" label="标准号" width="146" />
          <el-table-column prop="standard_name" label="标准名称" min-width="325" />
          <el-table-column prop="level" label="级别" min-width="188" />
          <el-table-column label="备注" min-width="148">
            <template slot-scope="scope">
              <a v-if="scope.row.file.url" :href="scope.row.file.url" target="_blank" class="wh-flex-start">在线浏览</a>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </wh-list>
  </div>
</template>

<script>
import { Instance } from '@/service/httpOther'
import WhList from '@/components/WhList/WhList'
import WhBreadcumb from '@/components/WhBreadcrumb/WhBreadcrumb'
export default {
  name: 'See',
  components: { WhBreadcumb, WhList },
  data() {
    Instance.defaults.baseURL = Instance.defaults.baseURL.replace('/standard', '') + `/standard`
    return {
      breadcrumbList: [
        {
          name: '节能标准体系',
          to: {
            path: '/info/structure'
          }
        }
      ],
      menu: '',
      parameter: {
        search: '',
        classification_id: null
      },
      dataSrc: Instance
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
    key() {
      return this.$route.query.key || null
    }
  },
  watch: {
    params: {
      handler(newV, oldV) {
        this.breadcrumbFn()
      },
      immediate: true,
      deep: true
    },
    key: {
      handler(newV, oldV) {
        this.parameter.search = newV
      },
      immediate: true
    }
  },
  methods: {
    breadcrumbFn() {
      this.breadcrumbList = [
        {
          name: '节能标准体系',
          to: {
            path: '/info/structure'
          }
        }
      ]
      this.$store.dispatch('getClass', 0).then(navList => {
        if (this.$route.params.thr) {
          const sup = navList.find(item => item.id === (this.$route.params.sup || null))
          if (sup) {
            this.breadcrumbList.push({ name: sup.title, to: '' })
            const child = sup.child.find(item => item.id === this.$route.params.child)
            if (child) {
              this.breadcrumbList.push({ name: child.title, to: '' })
              const thr = child.child.find(item => item.id === this.$route.params.thr)
              if (thr) {
                this.menu = thr.title
                this.breadcrumbList.push({ name: thr.title, to: '' })
              }
            }
          }
          this.parameter.classification_id = this.$route.params.thr
        } else if (this.$route.params.child) {
          const sup = navList.find(item => item.id === (this.$route.params.sup || null))
          if (sup) {
            this.breadcrumbList.push({ name: sup.title, to: '' })
            const child = sup.child.find(item => item.id === this.$route.params.child)
            if (child) {
              this.menu = child.title
              this.breadcrumbList.push({ name: child.title, to: '' })
            }
          }
          this.parameter.classification_id = this.$route.params.child
        }
      })
    },
    getListData(res) {
      const resp = res.data
      return resp.data.map((item, index) => {
        return {
          ...item
        }
      })
    },
    getTotal(res) {
      return res.total || 0
    },
    tableCellStyle() {
      return 'border-color: #fff;color: #10132C;'
    },
    // 修改 table header cell的背景色
    tableHeaderCellStyle() {
      return 'border-color: #fff;'
    }
  }
}
</script>

<style lang="less" scoped>
  .info-see{
    padding-bottom: 30px;
    .level-list{
      padding: 0;
    }
  }
  /deep/ .breadcumb-warp{
    padding-left: 16px;
  }
  /deep/.see-table{
    th{
      &:first-child{
        text-align: center;
      }
    }
    tbody tr:hover>td {
      background-color: #EDEDEF!important;
      color: #0074C1!important;
    }
  }
</style>
